import React from 'react'

import type { FilterControlProps } from 'features/charts-v2'
import type { FilterOption } from 'features/filters/types'
import type {
  AgentStaleFilter,
  FilterCriterion,
  StaleByField,
} from 'features/trend-detection/types'
import {
  BenchmarkingAgentConfigForm,
  type BenchmarkingEntityType,
} from 'src/components/agent-forms/BenchmarkingAgentConfigForm'

/** Everything `BenchmarkingAgentConfigForm` needs except name (owned by the
 * shared `AgentNameTitle` at the top of the unified form now) — bundled into
 * one prop so this wrapper stays well under the component prop-count
 * threshold despite forwarding a wide, pre-existing form's surface. */
export interface BenchmarkingFieldsBundle {
  entityType: BenchmarkingEntityType | null
  onEntityTypeChange: (type: BenchmarkingEntityType) => void
  filterControlProps: FilterControlProps
  cohortFilters: FilterCriterion[]
  focusGroupFilters: FilterCriterion[]
  onFocusGroupFiltersChange: (filters: FilterCriterion[]) => void
  projectId: string | null
  focusGroupFilterOptions: FilterOption[] | undefined
  focusGroupFilterOptionsLoading: boolean
  staleFocusByField?: StaleByField
  staleFilters?: readonly AgentStaleFilter[]
  isEditor?: boolean
  onRemoveStaleValue?: (removal: {
    field: string
    value: string | null
  }) => void
}

export interface BenchmarkingAgentFieldsProps {
  fields: BenchmarkingFieldsBundle
}

/** Benchmarking Agent's Instructions body: the Universe/Focus panel + live
 * stats. Reuses the shared `BenchmarkingAgentConfigForm` verbatim (also
 * consumed by the edit panel and the admin modal) rather than
 * re-implementing its `BenchmarkUniversePanel` and switch-entity-type
 * confirmation flow — this is a thin `nameEditable=false` wrapper, not a
 * rewrite. */
export const BenchmarkingAgentFields: React.FC<
  BenchmarkingAgentFieldsProps
> = ({ fields }) => (
  <BenchmarkingAgentConfigForm
    name=""
    onNameChange={() => {}}
    nameEditable={false}
    {...fields}
  />
)
